import React from 'react';
import PropTypes from 'prop-types';
import NavBarItem from './NavBarItem';
import { Message, WebMediaQuery } from '@aperza/ui';
import { AppService } from '@aperza/util';
const appConfig = AppService.appConfig();
export default class SignUpLink extends React.Component {
    render() {
        let signUpUrl = `https://id${appConfig.baseComDomain}/signup/register.html`;
        if (appConfig.isAperzaMarketplace || !this.props.disableMarketplaceBanner) {
            signUpUrl = `https://order${appConfig.baseComDomain}/member/index.html`;
        }
        return (React.createElement(WebMediaQuery, { largeDesktopOnly: true },
            React.createElement(NavBarItem, { title: React.createElement(Message, { messageId: "navbar.signUp" }), icon: "signup", className: "sign-up", url: signUpUrl })));
    }
}
SignUpLink.propTypes = {
    viewer: PropTypes.shape({
        disableMarketplaceBanner: PropTypes.bool,
    }),
};
